import { createColumnHelper } from '@tanstack/react-table';
import { ActionsCell, UserRoleCell, UserTeamCell } from './UserCells';
import { FirestoreUser } from 'generated/graphql';

const columnHelper = createColumnHelper<FirestoreUser>();

const UsersColumns = [
    columnHelper.accessor('displayName', {
        header: 'Display Name',
    }),
    columnHelper.accessor('firstName', {
        header: 'Given Name',
    }),
    columnHelper.accessor('lastName', {
        header: 'Surname',
    }),
    columnHelper.accessor('email', {
        header: 'Email',
    }),
    columnHelper.accessor('teamId', {
        header: 'Team',
        cell: UserTeamCell,
    }),
    columnHelper.accessor('roles', {
        header: 'Role',
        cell: UserRoleCell,
    }),
    columnHelper.accessor('id', {
        header: 'Actions',
        cell: ActionsCell,
    }),
];

export default UsersColumns;
